import React from 'react';
import ConditionValue from './ConditionValue';
import {OPERATORS_WITH_VALUES_PROPERTY} from '../../../../../../data/reducers/query';
import BinaryValueSelection from './BinaryValueSelection';

function OperatorValues(props) {
    const {field, operator, values, onChange, onAdd} = props;

    if (!operator) return null;
    if (!OPERATORS_WITH_VALUES_PROPERTY.includes(operator.id)) return null;
    if (operator.values?.length == 2 && values.length <= 1) {
        return <BinaryValueSelection operator={operator} value={values[0]} onChange={value => onChange(0, value)} />;
    }

    // NOTE: returning an array instead of a Fragment to prevent losing focus when new elements are added

    return [
        /* Exiting values */
        ...values.map((value, i) => <ConditionValue key={i} field={field} operator={operator} value={value} onChange={value => onChange(i, value)} />),
        /* Add new value */
        <ConditionValue key={values.length} operator={operator} value="" onChange={onAdd} />,
    ];
}

export default OperatorValues;
